import { Button } from '@talentmesh/ui/components/button';
import { Input } from '@talentmesh/ui/components/input';
import { Label } from '@talentmesh/ui/components/label';
import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { FormProvider } from 'react-hook-form';
import { useEmailIntegrationStatus } from '../../../../../../AccountSettings/AccountSettingsTabs/IntegrationsTab/api/useOAuthEmailIntegration';
import EmailCandidateEditor from './EmailCandidateEditor/EmailCandidateEditor';
import { useEmailCandidateForm } from './useEmailCandidateForm';
import TMWingsAnimation from '@/Components/Animations/TMWingsAnimation/TMWingsAnimation';
import TypingTextAnimation from '@/Components/Animations/TypingTextAnimation';
import { useUserContext } from '@/Context/UserContext';
import UIStrings from '@/Utils/UIStrings';

interface EmailCandidateFormProps {
    onSubmit: Parameters<ReturnType<typeof useEmailCandidateForm>['handleSubmit']>['0'];
}

const EmailCandidateForm = ({ onSubmit }: EmailCandidateFormProps) => {
    const form = useEmailCandidateForm();
    const { user } = useUserContext();
    const { data: integration } = useEmailIntegrationStatus();

    const handleSubmit = form.handleSubmit(onSubmit);

    return (
        <FormProvider {...form}>
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                <div className="flex flex-col gap-2">
                    <Label className="capitalize">{UIStrings.From}</Label>
                    <Input
                        readOnly
                        disabled
                        value={`${user.firstName} ${user.lastName} <${integration?.emailAddress || ''}>`}
                        className="bg-muted"
                    />
                </div>
                <div className="flex flex-col gap-2">
                    <Label htmlFor="subject">{UIStrings.Subject}</Label>
                    {form.formState.isLoading ? (
                        <div className="border-input bg-background flex h-10 w-full items-center gap-1 rounded-xl border p-2">
                            <TMWingsAnimation width="28px" height="28px" />
                            <TypingTextAnimation deletionSpeed={20} texts={[UIStrings.GeneratingSubjectWithAI]} />
                        </div>
                    ) : (
                        <RHFInput className="w-full" placeholder={UIStrings.AddSubject} {...form.register('subject')} />
                    )}
                </div>
                <EmailCandidateEditor />
                <div className="flex justify-end gap-2">
                    <Button
                        type="submit"
                        size="lg"
                        disabled={form.formState.disabled || form.formState.isLoading || form.formState.isSubmitting}
                    >
                        {form.formState.isSubmitting && <Spinner className="size-4" />}
                        {UIStrings.SendEmail}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};

export default EmailCandidateForm;
